import initDeleteTagModal from '../../../../tags/init_delete_tag_modal.js?vue3';
import initIssuablePopovers from '../../../../issuable/popover/index.js?vue3';

initDeleteTagModal();
initIssuablePopovers(document.querySelectorAll('[data-reference-type="commit"]'));
